import { createStore } from "@ngneat/elf";
import { withEntities } from "@ngneat/elf-entities";
import { withRequestsStatus } from "@ngneat/elf-requests";
import { Template } from "./templates.model";


export const templatesStore = createStore({ name: "templates" }, withEntities<Template>(), withRequestsStatus());
